import { StoreRecord } from "../types/store";

export const mockStores: StoreRecord[] = [
  {
    id: "store-1001",
    storeNumber: "1001",
    displayName: "Atlanta Perimeter",
    city: "Atlanta",
    state: "GA",
    country: "US",
    region: "Southeast",
    ownershipType: "Corporate",
    franchiseGroup: null,
    emails: ["atlanta.perimeter@edible.test", "ga.ops@edible.test"],
  },
  {
    id: "store-1002",
    storeNumber: "1002",
    displayName: "Buckhead",
    city: "Atlanta",
    state: "GA",
    country: "US",
    region: "Southeast",
    ownershipType: "Franchise",
    franchiseGroup: "Sunbelt Hospitality",
    emails: ["buckhead@edible.test"],
  },
  {
    id: "store-1021",
    storeNumber: "1021",
    displayName: "Orlando South",
    city: "Orlando",
    state: "FL",
    country: "US",
    region: "Southeast",
    ownershipType: "Franchise",
    franchiseGroup: "Sunbelt Hospitality",
    emails: ["orlando.south@edible.test", "sunbelt.ops@edible.test"],
  },
  {
    id: "store-1104",
    storeNumber: "1104",
    displayName: "Dallas Uptown",
    city: "Dallas",
    state: "TX",
    country: "US",
    region: "Southwest",
    ownershipType: "Corporate",
    franchiseGroup: null,
    emails: ["dallas.uptown@edible.test"],
  },
  {
    id: "store-1109",
    storeNumber: "1109",
    displayName: "Plano Legacy",
    city: "Plano",
    state: "TX",
    country: "US",
    region: "Southwest",
    ownershipType: "Franchise",
    franchiseGroup: "Lone Star Fruit Co.",
    emails: ["plano.legacy@edible.test"],
  },
  {
    id: "store-1203",
    storeNumber: "1203",
    displayName: "Chicago Loop",
    city: "Chicago",
    state: "IL",
    country: "US",
    region: "Midwest",
    ownershipType: "Corporate",
    franchiseGroup: null,
    emails: ["chicago.loop@edible.test", "midwest.corp@edible.test"],
  },
  {
    id: "store-1215",
    storeNumber: "1215",
    displayName: "Naperville Riverwalk",
    city: "Naperville",
    state: "IL",
    country: "US",
    region: "Midwest",
    ownershipType: "Franchise",
    franchiseGroup: "Great Lakes Partners",
    emails: ["naperville@edible.test"],
  },
  {
    id: "store-1224",
    storeNumber: "1224",
    displayName: "Detroit Midtown",
    city: "Detroit",
    state: "MI",
    country: "US",
    region: "Midwest",
    ownershipType: "Franchise",
    franchiseGroup: "Great Lakes Partners",
    emails: [],
  },
  {
    id: "store-1301",
    storeNumber: "1301",
    displayName: "Boston Back Bay",
    city: "Boston",
    state: "MA",
    country: "US",
    region: "Northeast",
    ownershipType: "Corporate",
    franchiseGroup: null,
    emails: ["boston.backbay@edible.test"],
  },
  {
    id: "store-1319",
    storeNumber: "1319",
    displayName: "Brooklyn Heights",
    city: "Brooklyn",
    state: "NY",
    country: "US",
    region: "Northeast",
    ownershipType: "Franchise",
    franchiseGroup: "Metro Gifting Group",
    emails: ["brooklyn.heights@edible.test", "metro.group@edible.test"],
  },
  {
    id: "store-1327",
    storeNumber: "1327",
    displayName: "White Plains",
    city: "White Plains",
    state: "NY",
    country: "US",
    region: "Northeast",
    ownershipType: "Franchise",
    franchiseGroup: "Metro Gifting Group",
    emails: ["whiteplains@edible.test"],
  },
  {
    id: "store-1410",
    storeNumber: "1410",
    displayName: "Seattle Downtown",
    city: "Seattle",
    state: "WA",
    country: "US",
    region: "West",
    ownershipType: "Corporate",
    franchiseGroup: null,
    emails: ["seattle.downtown@edible.test"],
  },
  {
    id: "store-1501",
    storeNumber: "1501",
    displayName: "Toronto Harbourfront",
    city: "Toronto",
    state: "ON",
    country: "CA",
    region: "Canada East",
    ownershipType: "Corporate",
    franchiseGroup: null,
    emails: ["toronto.harbourfront@edible.test"],
  },
  {
    id: "store-1508",
    storeNumber: "1508",
    displayName: "Mississauga Square One",
    city: "Mississauga",
    state: "ON",
    country: "CA",
    region: "Canada East",
    ownershipType: "Franchise",
    franchiseGroup: "Maple Gift Group",
    emails: ["mississauga.squareone@edible.test"],
  },
];
